import Api from '@/Api'

export default class SelectOptionsApi extends Api {
  genders = () => {
    return this.get('/api/v1/private/utilities/genders')
  }

  relationships = () => {
    return this.get('/api/v1/private/utilities/relationships')
  }

  ethnicities = () => {
    return this.get('/api/v1/private/utilities/languages/ethnicity')
  }

  races = () => {
    return this.get('/api/v1/private/utilities/languages/race')
  }

  languages = () => {
    return this.get('/api/v1/private/utilities/languages/language')
  }
}
